const userAgent = window.navigator.userAgent
const platform = window.navigator.platform
const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
const iosPlatforms = ['iPhone', 'iPad', 'iPod']
let userOS = null

if (macosPlatforms.indexOf(platform) !== -1) {
  userOS = 'Mac'
} else if (iosPlatforms.indexOf(platform) !== -1) {
  userOS = 'iOS'
} else if (windowsPlatforms.indexOf(platform) !== -1) {
  userOS = 'Windows'
} else if (/Android/.test(userAgent)) {
  userOS = 'Android'
} else if (/Linux/.test(platform)) {
  userOS = 'Linux'
}

export const isMacOS = ((userOS === 'Mac') || (userOS === 'iOS'))

export const ctrlOrCmd = isMacOS ? 'cmd' : 'ctrl'
//
// const uAgent = userAgent.toLowerCase()
// const mobilePhones = ['iphone', 'ipod', 'ipad', 'android', 'blackberry', 'windows ce', 'nokia', 'webos', 'opera mini', 'sonyericsson', 'opera mobi', 'iemobile']
//
// globalOnDemandVars.set_isMobile(mobilePhones.some((somePhone) => (somePhone === uAgent)))
